export default {
    STREET1: 'street1',
    STREET2: 'street2',
    CITY: 'city',
    STATE: 'state',
    POSTAL_CODE: 'postal_code',
};
